import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const TermsAndConditions = () => {
  return (
    <div className="min-vh-100" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="container py-5">
        {/* Header */}
        <div className="text-white mb-4">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Logo color="white" width="300px" />
          </Link>
        </div>

        {/* Content Card */}
        <div className="card shadow-lg" style={{ borderRadius: '12px' }}>
          <div className="card-body p-5">
            <h2 className="mb-4" style={{ fontWeight: '700', color: '#2c3e50' }}>Terms and Conditions</h2>
            <p className="text-muted mb-4" style={{ fontSize: '0.875rem' }}>
              Last Updated: November 4, 2025
            </p>

            <div style={{ lineHeight: '1.8', color: '#4b5563' }}>
              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>1. Introduction</h4>
                <p>
                  Welcome to VoteWave, an online voting platform managed by VOTEWAVE SERVICES( "we", "us", or "our"). 
                  By accessing or using VoteWave, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, 
                  please do not use our platform.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>2. Service Description</h4>
                <p>
                  VoteWave provides an online platform for organizations to create, manage, and conduct elections and voting campaigns. 
                  Our services include:
                </p>
                <ul>
                  <li>Election creation and management</li>
                  <li>Candidate registration and profile management</li>
                  <li>Secure online voting</li>
                  <li>Real-time results and analytics</li>
                  <li>Multiple voting options with payment integration</li>
                  <li>Transaction processing and reporting</li>
                </ul>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>3. User Accounts and Registration</h4>
                <p><strong>3.1 Account Creation:</strong> To use VoteWave, you must create an account by providing accurate and complete information.</p>
                <p><strong>3.2 Account Security:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
                <p><strong>3.3 User Roles:</strong> VoteWave supports different user roles including Super Admins, Organization Admins, and Voters. Each role has specific permissions and responsibilities.</p>
                <p><strong>3.4 Email Verification:</strong> You must verify your email address to access certain features of the platform.</p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>4. Pricing and Payments</h4>
                <p><strong>4.1 Multiple Voting Charges:</strong> Organizations that enable multiple voting features will be charged based on their selected configuration. The pricing is determined by:</p>
                <ul>
                  <li>Vote price set by the organization</li>
                  <li>Maximum votes per user</li>
                  <li>Number of positions in the election</li>
                </ul>
                
                <p><strong>4.2 Transaction Fees:</strong> A transaction fee of UGX 300 per vote will be charged in addition to the organization's set vote price.</p>
                
                <p><strong>4.3 Payment Processing:</strong> All payments are processed securely through Flutterwave, our third-party payment gateway. VoteWave does not store, process, or have access to your credit card, debit card, or mobile money payment credentials. All payment information is handled directly by Flutterwave in compliance with PCI-DSS security standards.</p>
                
                <p><strong>4.4 Refunds:</strong> Votes cast and payments made are generally non-refundable unless required by law or in cases of technical errors on our platform.</p>
                
                <p><strong>4.5 Currency:</strong> Payments are processed in Ugandan Shillings (UGX) unless otherwise specified.</p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>5. Voting Rules and Conduct</h4>
                <p><strong>5.1 Fair Voting:</strong> Users must not engage in vote manipulation, fraud, or any activity that compromises the integrity of elections.</p>
                <p><strong>5.2 One Person, One Vote (Default):</strong> Unless multiple voting is enabled, each user may cast only one vote per position.</p>
                <p><strong>5.3 Multiple Voting:</strong> When enabled by organizations, users may purchase additional votes according to the configured limits.</p>
                <p><strong>5.4 Vote Privacy:</strong> Individual votes are kept confidential. Results show aggregate data only.</p>
                <p><strong>5.5 Election Periods:</strong> Votes can only be cast during active election periods as defined by the organization.</p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>6. Organization Responsibilities</h4>
                <p>
                  <strong>6.1 Content:</strong> Organizations are responsible for all content they upload, including election descriptions, candidate information, and images. This includes the exclusive responsibility for uploading and managing all candidate profiles and related media (e.g., photos). VoteWave does not create, upload, or modify candidate profiles or media.
                </p>
                <p>
                  <strong>6.2 Candidate Consent:</strong> Organizations warrant that they have obtained all necessary consents, licenses, and permissions from candidates to use their names, profiles, photos, and any other submitted information on the VoteWave platform. VOTEWAVE SERVICES is not responsible for any claims arising from an organization's failure to obtain such consent.
                </p>
                <p>
                  <strong>6.3 Compliance:</strong> Organizations must ensure their elections comply with all applicable laws and their own internal regulations.
                </p>
                <p>
                  <strong>6.4 Voter Management:</strong> Organizations are responsible for managing their voter lists and ensuring only eligible individuals can vote.
                </p>
                <p>
                  <strong>6.5 Results:</strong> Organizations determine result visibility settings and are responsible for announcing winners.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>7. Intellectual Property</h4>
                <p>
                  All content, features, and functionality on VoteWave, including but not limited to text, graphics, logos, and software, 
                  are the property of VOTEWAVE SERVICES and are protected by copyright, trademark, and other intellectual property laws.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>8. Data Protection and Privacy</h4>
                <p>
                  Your use of VoteWave is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information. 
                  By using VoteWave, you consent to our data practices as described in the Privacy Policy.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>9. Prohibited Activities</h4>
                <p>You may not:</p>
                <ul>
                  <li>Use the platform for any illegal or unauthorized purpose</li>
                  <li>Attempt to manipulate voting results through fraud or technical exploitation</li>
                  <li>Share your account credentials with others</li>
                  <li>Upload malicious code or interfere with the platform's operation</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Collect user information without consent</li>
                  <li>Reverse engineer or attempt to extract source code</li>
                </ul>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>10. Service Availability</h4>
                <p>
                  While we strive to maintain 99.9% uptime, we do not guarantee uninterrupted access to VoteWave. 
                  We reserve the right to modify, suspend, or discontinue any part of the service with or without notice.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>11. Limitation of Liability</h4>
                <p>
                  To the maximum extent permitted by law, VOTEWAVE SERVICES shall not be liable for any indirect, incidental, 
                  special, consequential, or punitive damages resulting from your use or inability to use VoteWave.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>12. Termination</h4>
                <p>
                  We reserve the right to suspend or terminate your account at any time if you violate these Terms and Conditions 
                  or engage in fraudulent or illegal activities.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>13. Changes to Terms</h4>
                <p>
                  We may update these Terms and Conditions from time to time. We will notify users of significant changes through 
                  email or platform notifications. Your continued use of VoteWave after changes constitutes acceptance of the new terms.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>14. Governing Law</h4>
                <p>
                  These Terms and Conditions shall be governed by and construed in accordance with the laws of Uganda. 
                  Any disputes shall be subject to the exclusive jurisdiction of the courts of Uganda.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>15. Contact Information</h4>
                <p><strong>VOTEWAVE SERVICES</strong></p>
                <p>
                  For questions about these Terms and Conditions, please contact us at:<br />
                  Email: info@votewave.co.ug<br />
                  Website: www.votewave.co.ug
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '600', color: '#2c3e50', marginBottom: '1rem' }}>16. Acceptance</h4>
                <p>
                  By creating an account and using VoteWave, you acknowledge that you have read, understood, and agree to be bound 
                  by these Terms and Conditions.
                </p>
              </section>
            </div>

            <hr className="my-4" />

            <div className="d-flex justify-content-between align-items-center">
              <Link to="/" className="btn btn-outline-primary">
                <i className="bi bi-arrow-left me-2"></i>
                Back to Home
              </Link>
              <Link to="/privacy-policy" className="btn btn-link">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;